<template lang="html">
  <div class="login-form row">
    <div class="col-lg-6 col-md-12 col-sm-12 prima-colonna" style="border-right: 1px solid #666">
      <h1>LOGIN</h1>

      <b-form class="mt-4" @submit.prevent="is_forgot ? sendResetEmail() : login()">
        <b-form-group>
          <div class="field-title">Indirizzo e-mail</div>
          <b-input-group size="sm">
            <b-form-input v-model="form.email"
                          type="email"
                          trim
                          placeholder="Email"
                          autofocus/>
          </b-input-group>
        </b-form-group>
        <b-form-group v-if="!is_forgot">
          <div class="field-title">Password</div>
          <b-input-group size="sm" class="mb-2">
            <b-form-input v-model="form.password"
                          type="password"
                          placeholder="Password"/>
          </b-input-group>
        </b-form-group>
        <div class="">
          <div class="text-danger" v-if="errors">
            Login errato
          </div>
          <div class="mt-4 button-container">
            <b-button class="confirm-button" variant="primary" type="submit" :disabled="is_loading">
              {{ is_forgot ? 'Invia mail di recupero' : "LOGIN" }}
            </b-button>
          </div>
          <a href="#" @click.prevent="is_forgot=true">
            Password dimenticata?
          </a>
        </div>
      </b-form>

    </div>
    <div class="col-md-6 col-sm-12 seconda-colonna">
      <h2>
        Non sei ancora registrato?
      </h2>
      <a href="#" @click="$store.show_signup = true">
        REGISTRATI QUI
      </a>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      errors: false,
      is_loading: false,
      is_forgot: false
    }
  },

  methods: {
    login() {
      this.errors = null
      this.is_loading = true
      this.$http.post('login', this.form)
          .then(res => {
            this.$store.user = res.data.user
            this.$store.token = res.data.token

            this.$root.$bvToast.toast(`Ciao ${this.$store.user.full_name}. Autenticazione eseguita con successo!`, {
              title: `Conferma login`,
              variant:'success',
              solid: true,
              toaster: 'b-toaster-top-center',
              autoHideDelay: 3000,
            })

            this.$emit('close')
          }, err => {
            console.log(err.response)
            if (err.response && [401, 404].includes(err.response.status)) {
              this.errors = err.response.data
            }
          }).finally(() => {
        this.is_loading = false
      })
    },
    sendResetEmail() {
      this.errors = null
      this.is_loading = true
      this.$http.post('send-reset-mail', this.form)
          .then(() => {
            alert('Ti è stata mandata una mail per il ripristino')
            this.$emit('close')
          }, err => {
            console.log(err.response)
            if (err.response && [401, 404].includes(err.response.status)) {
              this.errors = err.response.data
            }
          }).finally(() => {
        this.is_loading = false
      })
    },
  }
}
</script>

<style>
.login-form {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
}

@media only screen and (max-width: 991px) {
  .prima-colonna {
    border-right: 0px !important;
  }

  .seconda-colonna {
    padding-top: 40px;
  }
}

.b-toaster-top-center{
  top: 20% !important;
}

.b-toast-success .toast {
  border: 1px solid #71b738 !important;
  border-radius:5px;
}

.b-toast-success .toast .toast-header {
  background-color: #71b738 !important;
  color: white !important;
  padding: 0.6em;
  font-size: larger;
}

.b-toast-success .toast .toast-body {
  background-color: white;
  font-size: larger;
  padding: 30px 1.2em;
  color: #71b738;
}


</style>
